import { ProductName } from "../Styles/ProductName";


export const UnlicensedTextView = () => (<>
	This report was generated by <ProductName /> exclusively to inform the user who generated it.
	This report may not be used for any audit-for hire, as evidence in a class action or mass arbitration, or other commercial purpose
	without a license from the software's author.
</>);
